const POPUP_RELAY_RESPONSE_TYPE = 'msal:popup-relay-response:v1';
const RELAY_TIMEOUT_MS = 300000;

type RelayRequest = {
  id?: string;
  url?: string;
  method?: string;
};

const scrubHash = () => {
  if (typeof window.history.replaceState === 'function') {
    window.history.replaceState(null, '', `${window.location.origin}${window.location.pathname}`);
  }
};

const entraTarget = (url: string) => {
  let target: URL;

  try {
    target = new URL(url, window.location.origin);
  } catch {
    return undefined;
  }

  const isEntraHost =
    target.hostname === 'login.microsoftonline.com' || target.hostname.endsWith('.microsoftonline.com');

  return target.protocol === 'https:' && isEntraHost ? target : undefined;
};

export const readPopupRelayRequest = (): RelayRequest | undefined => {
  const raw = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('req');

  if (!raw) {
    return undefined;
  }

  try {
    return JSON.parse(raw) as RelayRequest;
  } catch {
    return undefined;
  }
};

export const isPopupRelaySupported = (request: RelayRequest | undefined): request is RelayRequest =>
  !!request?.id && !!request.url && request.method !== 'POST';

export const runEntraPopupRelay = (request: RelayRequest) => {
  const { id } = request;
  const opener = window.opener as Window | null;
  const target = entraTarget(request.url ?? '');

  if (!id || !opener || !target) {
    return;
  }

  scrubHash();

  let settled = false;
  const timers: { timeoutId?: number } = {};
  const channel = new BroadcastChannel(id);

  const relay = (message: { payload?: string; error?: string }) => {
    if (settled) {
      return;
    }
    settled = true;
    window.clearTimeout(timers.timeoutId);
    try {
      channel.close();
    } catch {
      /* already closed */
    }
    opener.postMessage({ type: POPUP_RELAY_RESPONSE_TYPE, id, ...message }, window.location.origin);
    window.setTimeout(() => {
      try {
        window.close();
      } catch {
        /* ignore */
      }
    }, 0);
  };

  timers.timeoutId = window.setTimeout(() => relay({ error: 'timed_out' }), RELAY_TIMEOUT_MS);

  channel.onmessage = event => {
    const payload = (event.data as { payload?: string } | null)?.payload;
    if (payload) {
      relay({ payload });
    }
  };

  if (!window.open(target.toString(), 'msalPopupRelayChild', 'width=520,height=640,scrollbars=yes')) {
    relay({ error: 'popup_window_error' });
  }
};
